// extracted by mini-css-extract-plugin
export var screenLg = "992px";
export var screenXl = "1200px";
export var screenMd = "768px";
export var screenSm = "576px";
export var screenXlMax = "1199px";
export var screenLgMax = "991px";
export var screenMdMax = "767px";
export var screenSmMax = "575px";
export var Promo = "Promo-module--Promo--HRc09";
export var Promo__wrapper = "Promo-module--Promo__wrapper--2n5fO";
export var Promo__promoSlotContainer = "Promo-module--Promo__promoSlotContainer--ha7jq";
export var Promo__heroSlot = "Promo-module--Promo__heroSlot--1SZgp";
export var Promo__heroSlot__imageContainer = "Promo-module--Promo__heroSlot__imageContainer--1oWMh";
export var Promo__heroSlot__textWrap = "Promo-module--Promo__heroSlot__textWrap--1EXYc";
export var Promo__heroSlot__header = "Promo-module--Promo__heroSlot__header--1jECL";
export var Promo__heroSlot__title = "Promo-module--Promo__heroSlot__title--392Rs";
export var Promo__maskBackground = "Promo-module--Promo__maskBackground---Lcm3";